import { render } from "./MultiStep.vue?vue&type=template&id=13233b6e&ts=true"
import script from "./MultiStep.vue?vue&type=script&lang=ts"
export * from "./MultiStep.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__